import Skeleton from '../../common/skeleton';
import Lock from '../../../img/Lock.svg';

const SkeletonAccountLockedSkeleton = () => {
  return (
    <div className="account-locked-page">
      <div className="account-locked-content">
        {/*Logo placeholder */}
        <div>
          <img className="help-card-logo" src={Lock} alt="logo" />
        </div>

        <h1 className="account-locked-title">
          Your account has been locked due to
          <br />
          too many invalid login attempts
        </h1>

        {/*Description placeholder */}
        <p className="account-locked-description">
          <Skeleton height={20} width="100%" />
        </p>

        {/*Action button placeholder */}
        <div className="account-locked-action">
          <Skeleton height={40} width={200} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonAccountLockedSkeleton;
